var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 850.39 850.39",
    style: {
      enableBackground: "new 0 0 850.39 850.39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#E0611A;stroke-width:113.3858;stroke-linecap:round;}\r\n\t.st1{fill:none;stroke:#E0611A;stroke-width:113.3858;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "translate(662 534)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_223",
    className: "st0",
    x1: -520.36,
    y1: -108.94,
    x2: -37.73,
    y2: -108.94
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_563",
    className: "st1",
    d: "M-158.6-307.36L46.57-108.94L-158.6,89.49"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.b1dc543625b6c2badeea18a0f80ebd9c.svg";
export { ForwardRef as ReactComponent };